import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
    static values = {
        promotionId: Number,
        cookieDays: { type: Number, default: 1 },
        delay: { type: Number, default: 2000 },
    }

    static targets = ['modal']

    connect() {
        if (!this.shouldShowBanner()) {
            return;
        }

        this.modalTarget.addEventListener('hidden.bs.modal', this.onModalHidden.bind(this));

        setTimeout(() => {
            this.showBanner();
        }, this.delayValue);
    }

    disconnect() {
        this.modalTarget.removeEventListener('hidden.bs.modal', this.onModalHidden.bind(this));

        if (this.modal) {
            this.modal.dispose();
        }
    }

    shouldShowBanner() {
        const cookieName = this.getCookieName();
        const cookieValue = this.getCookie(cookieName);

        if (cookieValue === 'dismissed') {
            return false;
        }

        return true;
    }

    showBanner() {
        this.modal = new Modal(this.modalTarget);
        this.modal.show();
    }

    onModalHidden() {
        this.setCookie();
    }

    onButtonClick() {
        this.setCookie();
    }

    getCookieName() {
        return `promo_banner_dismissed`;
    }

    setCookie() {
        const cookieName = this.getCookieName();
        const days = this.cookieDaysValue;
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${cookieName}=dismissed;${expires};path=/;SameSite=Lax`;
    }

    getCookie(name) {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    }
}